<template>
  <div>
    <div>

      <div class="grid_line_three mb-5">
        <!-- loading_quantity_report -->
        <div class="ma-2">
          <v-card elevation="6">
            <div class="pa-5">
              <v-row>

                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <div class="font-22"><b>ข้อมูลทั่วไป</b></div>
                </v-col>

                <v-col cols="6">
                  <div class="font-18">
                    <span class="text-grey">ชื่อสาขา : </span> {{ storeDetail.name }}
                  </div>
                </v-col>

                <!-- <v-col cols="6 pt-0">
          <div class="font-18">
            <span class="text-grey">เลขที่เสียภาษี : </span> {{ storeDetail.tax_id }}
          </div>
        </v-col> -->

                <v-col cols="6 ">
                  <div class="font-18">
                    <span class="text-grey">เบอร์โทร : </span> {{ storeDetail.telephone }}
                  </div>
                </v-col>

                <v-col cols="6 pt-0">
                  <div class="font-18">
                    <span class="text-grey">ที่อยู่ : </span> {{ storeDetail.address }}
                  </div>
                </v-col>

                <v-col cols="6 pt-0">
                  <div class="font-18">
                    <span class="text-grey">รหัสสีตรีมร้าน : </span> {{ storeDetail.themeColor }}
                    <div class="orange lighten-4 px-4 mx-2" :style="{ backgroundColor: storeDetail.themeColor }"></div>
                  </div>
                </v-col>

              </v-row>
            </div>
          </v-card>
        </div>

      </div>

      <div class="mb-5">
        <!-- loading_dump_report -->
        <v-card elevation="6" class="ma-2">
          <div class="pa-3">
            <v-row>
              <v-col cols="12" sm="6" md="7" lg="8" xl="8" class="flex">
                <v-img height="50" max-width="50" :lazy-src="img_chart" :src="img_chart" />
                <div class="pt-3 pl-4" style="font-size: 22px"><b>รายงานยอดขาย</b></div>
              </v-col>

              <!-- เลือกเดือน -->
              <v-col>
                <div class="mt-4">
                  <v-select v-model="selected_month_sale" :items="month" item-text="name" item-value="id"
                    prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined dense
                    color="#86bc3a" />
                </div>
              </v-col>

              <!-- เลือกปี -->
              <v-col>
                <div class="mt-4">
                  <v-select v-model="selected_year_sale" :items="year_arr" item-text="show_year" item-value="year_eng"
                    prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined dense
                    color="#86bc3a" />
                </div>

              </v-col>
              <v-btn color="#86bc3a" style="margin-top: 30px; margin-right: 15px;" dark @click="onSearchChart">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>

            </v-row>

          </div>

          <div class="pa-3" style="height: 40vh !important">
            <canvas id="myChart"></canvas>
          </div>
        </v-card>
      </div>



      <div class="mb-5">
        <!-- loading_dump_report -->
        <v-card elevation="6" class="ma-2">
          <div class="pa-3">
            <v-row>
              <v-col cols="12" sm="8" md="9" lg="9" xl="9" class="flex">
                <v-img height="50" max-width="50" :lazy-src="img_chart_two" :src="img_chart_two" />
                <div class="pt-3 pl-4" style="font-size: 22px"><b>กราฟเปรียบเทียบยอดสั่งซื้อ</b></div>
              </v-col>

              <v-col>
                <div class="mt-4">
                  <v-select color="#86bc3a" @input="dump_tax_report_select()" :items="year_arr"
                    v-model="selected_year_wholesale" item-text="show_year" item-value="year_eng"
                    prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined
                    dense></v-select>
                </div>

              </v-col>
              <v-btn color="#86bc3a" style="margin-top: 30px; margin-right: 15px;" dark @click="onSearchWholesaleChart">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>


            </v-row>
          </div>

          <div class="pa-3" style="height: 60vh !important">
            <canvas id="myChart_store_other"></canvas>
          </div>
        </v-card>
      </div>


      <!-- loading_quantity_report -->
      <div class="ma-2">
        <v-row>
          <!-- บล็อก สินค้าขายดี ขยายเต็มความกว้าง -->
          <v-col cols="12">
            <v-card elevation="6">
              <div class="pa-3">
                <v-row>
                  <!-- หัวเรื่อง+ไอคอน -->
                  <v-col cols="12" class="flex">
                    <v-img height="50" max-width="60" :lazy-src="img_box" :src="img_box" />
                    <div class="pt-3 pl-4" style="font-size: 22px">
                      <b>สินค้าขายดี 10 อันดับ ประจำเดือน</b>
                    </div>
                  </v-col>

                  <!-- เลือกประเภทสินค้า -->
                  <v-row class="ml-2">
                    <!-- ประเภทสินค้า -->
                    <v-col cols="12" md="5">
                      <v-select v-model="selectedProductType" :items="productTypes" item-text="name" item-value="id"
                        label="ประเภทสินค้า" multiple outlined dense color="#86bc3a" />
                    </v-col>

                    <!-- เลือกเดือน -->
                    <v-col cols="6" md="3">
                      <v-select v-model="selectedBestMonth" :items="month" item-text="name" item-value="id"
                        prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" outlined dense color="#86bc3a" />
                    </v-col>

                    <!-- เลือกปี -->
                    <v-col cols="6" md="3">
                      <v-select v-model="selectedBestYear" :items="year_arr" item-text="show_year" item-value="year_eng"
                        prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." outlined dense
                        color="#86bc3a" />
                    </v-col>

                    <!-- ปุ่มค้นหา -->
                      <v-btn @click="loadBestSellingProducts" style="margin-top: 12px; margin-right: 10px;" color="#86bc3a" dark>
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                  </v-row>

                </v-row>

                <!-- ตารางผลลัพธ์ -->
                <v-data-table :headers="header_data_mock" :items="topProducts" item-key="code" hide-default-footer
                  class="mt-4">
                  <template #item="{ item }">
                    <tr>
                      <td>{{ item.no }}</td>
                      <td>{{ item.name }}</td>
                      <td class="text-left">{{ format_number(item.qty) }}</td>
                      <td class="text-left">{{ format_number(item.total) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>

              <div class="text-center py-5">
                <a href="#" class="success--text" @click.prevent="loadBestSellingProducts">
                  ดูทั้งหมด
                </a>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>

  </div>
</template>

<script>
import img_store from "@/assets/store.png"
import img_chart from "@/assets/chart.png"
import img_chart_two from "@/assets/chart_two.png"
import img_note from "@/assets/note.png"
import img_note_chart from "@/assets/snack.png"
import img_box from "@/assets/box_three.png"
import img_box_one from "@/assets/box_one.png"
import { formatNumber } from "@/js/handler";
import Chart from 'chart.js/auto';
import { HTTP } from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Warehouse_report",
  data() {
    return {
      overlay: false,
      img_store: img_store,
      img_chart: img_chart,
      img_chart_two: img_chart_two,
      img_note: img_note,
      img_box: img_box,
      img_box_one: img_box_one,
      img_note_chart: img_note_chart,

      selected_month_sale: new Date().getMonth() + 1,
      selected_year_sale: new Date().getFullYear(),
      selected_year_wholesale: new Date().getFullYear(),

      console_chart: null,
      selected_year: null,
      search_tatol_report: '',
      search: '',
      myChart: null,
      myChart_store_other: null,
      year: 2022,
      storeDetail: {
        id: '',
        name: '',
        tax_id: '',
        telephone: '',
        address: '',
        themeColor: '#ffffff',
      },
      productTypes: [],            // เก็บประเภทสินค้า
      selectedProductType: [],     // v-model ของประเภทที่เลือก
      selectedBestMonth: new Date().getMonth() + 1,
      selectedBestYear: new Date().getFullYear(),
      topProducts: [],
      selectedWorstProductType: [],
      selectedWorstMonth: new Date().getMonth() + 1,
      selectedWorstYear: new Date().getFullYear(),
      worstProducts: [],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      month: [
        { id: 1, name: 'มกราคม' },
        { id: 2, name: 'กุมภาพันธ์' },
        { id: 3, name: 'มีนาคม' },
        { id: 4, name: 'เมษายน' },
        { id: 5, name: 'พฤษภาคม' },
        { id: 6, name: 'มิถุนายน' },
        { id: 7, name: 'กรกฎาคม' },
        { id: 8, name: 'สิงหาคม' },
        { id: 9, name: 'กันยายน' },
        { id: 10, name: 'ตุลาคม' },
        { id: 11, name: 'พฤศจิกายน' },
        { id: 12, name: 'ธันวาคม' },
      ],

      year_arr: [],
      data_arr: [],

      header: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '260px',
        },
        {
          text: 'ชื่อทางวิทยาศาสตร์',
          value: 'product_name_sci',
          fixed: true,
          width: '200px',
        },
        {
          text: 'คลังหลัก',
          value: 'mains',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังใกล้หมดอายุ',
          value: 'expireds',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังชำรุด',
          value: 'damages',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอคืน',
          value: 'returns',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอลดหนี้',
          value: 'reducts',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังทิ้ง',
          value: 'dumps',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังโปรโมชั่น',
          value: 'promotions',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '180px',
        },
      ],

      header_tatol_day_report: [
        {
          text: 'ชื่อสาขา',
          value: 'store_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันที่ 1',
          value: 'date_1',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 2',
          value: 'date_2',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 3',
          value: 'date_3',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 4',
          value: 'date_4',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 5',
          value: 'date_5',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 6',
          value: 'date_6',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 7',
          value: 'date_7',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 8',
          value: 'date_8',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 9',
          value: 'date_9',
          fixed: true,
          width: '50px',
        },
      ],

      header_tatol_month_report: [
        {
          text: 'ชื่อสาขา',
          value: 'store_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ม.ค.',
          value: 'date_1',
          fixed: true,
          width: '50px',
        },
        {
          text: 'ก.พ.',
          value: 'date_2',
          fixed: true,
          width: '50px',
        },
        {
          text: 'มี.ค.',
          value: 'date_3',
          fixed: true,
          width: '50px',
        },
        {
          text: 'เม.ย.',
          value: 'date_4',
          fixed: true,
          width: '50px',
        },
        {
          text: 'พ.ค.',
          value: 'date_5',
          fixed: true,
          width: '50px',
        },
        {
          text: 'มิ.ย.',
          value: 'date_6',
          fixed: true,
          width: '50px',
        },
        {
          text: 'ก.ค.',
          value: 'date_7',
          fixed: true,
          width: '50px',
        },
        {
          text: 'ส.ค.',
          value: 'date_8',
          fixed: true,
          width: '50px',
        },
        {
          text: 'ก.ย.',
          value: 'date_9',
          fixed: true,
          width: '50px',
        },
      ],

      data_tatol_report_list: [
        {
          store_name: 'สาขา MAYA เชียงใหม่',
          date_1: 7000,
          date_2: 8000,
          date_3: 9000,
          date_4: 10000,
          date_5: 11000,
          date_6: 12000,
          date_7: 13000,
          date_8: 14000,
          date_9: 15000,
        },
        {
          store_name: 'สาขาโรบินสัน',
          date_1: 11000,
          date_2: 12000,
          date_3: 13000,
          date_4: 14000,
          date_5: 15000,
          date_6: 16000,
          date_7: 17000,
          date_8: 18000,
          date_9: 19000,
        },
        {
          store_name: 'สาขาเชียงราย',
          date_1: 20000,
          date_2: 21000,
          date_3: 22000,
          date_4: 23000,
          date_5: 24000,
          date_6: 25000,
          date_7: 26000,
          date_8: 27000,
          date_9: 28000,
        }
      ],

      data_list: [],
      graph_list: [],
      header_data_mock: [
        {
          text: 'ลำดับ',
          value: 'no',
          fixed: true,
          width: '10px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '170px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ราคา',
          value: 'total',
          fixed: true,
          width: '100px',
        },
      ],

      header_data_vat:
        [
          {
            text: 'วันที่',
            value: 'vat_date',
            fixed: true,
            width: '10px',
          },
          {
            text: 'เลขที่ใบเสร็จ',
            value: 'vat_bill',
            fixed: true,
            width: '130px',
          },
          {
            text: 'ชื่อลูกค้า',
            value: 'vat_user',
            fixed: true,
            width: '150px',
          },
          {
            text: 'เลขประจำตัวผู้เสียภาษี',
            value: 'vat_passpost',
            fixed: true,
            width: '200px',
          },
          {
            text: 'สนญ.',
            value: 'vat_branch_sub',
            fixed: true,
            width: '100px',
          },
          {
            text: 'สาขา',
            value: 'vat_branch',
            fixed: true,
            width: '100px',
          },
          {
            text: 'มูลค่าสินค้า',
            value: 'vat_value',
            fixed: true,
            width: '130px',
          },
          {
            text: 'ภาษีมูลค่าเพิ่ม',
            value: 'vat_vat',
            fixed: true,
            width: '140px',
          },
          {
            text: 'เครดิตชาร์จ',
            value: 'vat_credit_charge',
            fixed: true,
            width: '150px',
          },
          {
            text: 'รวมทั้งสิ้น',
            value: 'vat_sum',
            fixed: true,
            width: '130px',
          },

        ],

      data_mock: [
        {
          no: 1,
          name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
          qty: 324,
        },
        {
          no: 2,
          name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
          qty: 200,
        },
        {
          no: 3,
          name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
          qty: 140,
        },
        {
          no: 4,
          name: 'ยาดม IZE JELLI BALM 7 G 29.-',
          qty: 324,
        },
        {
          no: 5,
          name: 'cr.DELANIN CREAM 5G 180.-',
          qty: 300,
        },
        {
          no: 6,
          name: 'cr.SUPIROCIN OINT 5G 95.-',
          qty: 295,
        }
      ],

      data_mock_price_good: [
        {
          no: 1,
          name: 'คอร์สรักษาสิว',
          qty: 100,
        },
        {
          no: 2,
          name: 'ซอฟต์ฟิลเลอร์ 1  CC ',
          qty: 88,
        },
        {
          no: 3,
          name: 'ซอฟต์ฟิลเลอร์ 3  CC ',
          qty: 70,
        },
        {
          no: 4,
          name: 'เมโสรักษาฝ้า กระ',
          qty: 74,
        },
        {
          no: 5,
          name: 'มาร์ครักษาสิว',
          qty: 70,
        },
        {
          no: 6,
          name: 'Treatment',
          qty: 68,
        }
      ],

      data_mock_vat: [
        {
          vat_date: '30/01/2023',
          vat_bill: 'inv-15774124',
          vat_user: 'ชิณณวรรธน์ ปุณณัตถ์',
          vat_passpost: '-',
          vat_branch_sub: '00000',
          vat_branch: '',
          vat_value: '149.07',
          vat_vat: '10.43',
          vat_credit_charge: '-',
          vat_sum: '159.50',
        },
        {
          vat_date: '30/01/2023',
          vat_bill: 'inv-15774123',
          vat_user: 'อติวัณณ์ วริทธิ์นันท์',
          vat_passpost: '-',
          vat_branch_sub: '00000',
          vat_branch: '',
          vat_value: '84.11',
          vat_vat: '5.89',
          vat_credit_charge: '-',
          vat_sum: '90.00',
        },
        {
          vat_date: '28/01/2023',
          vat_bill: 'inv-15774122',
          vat_user: 'ชัญญากรณัฐ ฐานิศวรร์',
          vat_passpost: '1234567890123',
          vat_branch_sub: '',
          vat_branch: '00012',
          vat_value: '2,479.00',
          vat_vat: '173.53',
          vat_credit_charge: '74.37',
          vat_sum: '2,726.00',
        },
      ],

    }
  },
  methods: {
    format_date(date) {
      let formatDate = date.split('-')
      return `${formatDate[2]}-${formatDate[1]}-${formatDate[0]}`
    },
    format_number: function (value) {
      return formatNumber(value)
    },

    generateDayHeaders(year, month) {
      const days = new Date(year, month, 0).getDate();
      this.daysInMonth = days;
      const headers = [
        { text: 'ชื่อร้านค้า', value: 'store_name', width: '200px', align: 'start' }
      ];
      for (let i = 1; i <= days; i++) {
        headers.push({
          text: `วันที่ ${i}`,
          value: `date_${i}`,
          width: '100px',
          align: 'left'
        });
      }
      this.header_tatol_day_report = headers;
    },

    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      let month_selected = count_year.getMonth() + 1
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_month_bill_payment = month_selected
      this.selected_year_bill_payment = this.year_arr[0].year_eng
      await this.dump_bill_payment_select()

      this.selected_year = this.year_arr[0].year_eng
      await this.dump_data_select()

      this.selected_month_tax_report = month_selected
      this.selected_year_tax_report = this.year_arr[0].year_eng
      await this.dump_tax_report_select()
    },
    async dump_bill_payment_select() {
      this.credit = 0
      this.debit = 0
      await HTTP.post('/inventory/dashboards/reportpay', {
        month: this.selected_month_bill_payment,
        year: this.selected_year_bill_payment
      }).then((res) => {
        if (res.data.success === true) {
          this.credit = res.data.credit
          this.debit = res.data.debit
        }
      })
    },
    async fetchStoreDetail(id) {
      try {
        const res = await HTTP.get(`/dashboards/getStoreDetail/${id}`)
        if (!res.data.success) throw new Error('ไม่พบสาขา')
        const o = res.data.object
        this.storeDetail = { id: o.id, name: o.name, telephone: o.telephone, address: o.address, themeColor: o.themeColor }
      } catch (e) {
        console.error('fetchStoreDetail error', e)
      }
    },
    async loadProductTypes() {
      try {
        const res = await HTTP.get('/dashboards/getProductTypes');
        if (res.data.success) {
          this.productTypes = res.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    // โหลด top 10 best selling products
    loadBestSellingProducts() {
      const storeId = this.storeDetail.id;
      // 1) เตรียมพาราม์: productType, month, year
      const types = this.selectedProductType.length
        ? this.selectedProductType.join(',')
        : 'null';
      const month = this.selectedBestMonth;
      const year = this.selectedBestYear;

      // 2) เรียก API
      HTTP.get(`/dashboards/bestBranchSellingProducts/${storeId}/${types}/${month}/${year}`)
        .then(res => {
          if (!res.data.success) return;
          // 3) แมปข้อมูลกลับมาแสดง
          this.topProducts = res.data.top_products.map((p, idx) => ({
            no: idx + 1,
            code: p.product_code,
            name: p.product_name,
            qty: Number(p.total_qty),
            total: Number(p.total_amount)
          }));
        })
        .catch(console.error);
    },
    async loadWorstSellingProducts() {
      const storeId = this.storeDetail.id;
      const types = this.selectedWorstProductType.length
        ? this.selectedWorstProductType.join(',')
        : 'null';
      const month = this.selectedWorstMonth;
      const year = this.selectedWorstYear;

      try {
        const res = await HTTP.get(
          `/dashboards/worstBranchSellingProducts/${storeId}/${types}/${month}/${year}`
        );
        if (!res.data.success) return;

        this.worstProducts = res.data.top_products.map((p, idx) => ({
          no: idx + 1,
          code: p.product_code,
          name: p.product_name,
          qty: Number(p.total_qty),
        }));
      } catch (e) {
        console.error('loadWorstSellingProducts error', e);
      }
    },
    onSearchBestSelling() {
      this.loadBestSellingProducts();
    },
    onSearchChart() {
      // ถ้าเลือกหลายร้าน จะได้ Array ให้ join ด้วย comma ไม่งั้น 'null'
      const storeId = this.storeDetail.id;
      const year = this.selected_year_sale;
      const month = this.selected_month_sale;

      HTTP.get(`/dashboards/saleReportByStore/${storeId}/${year}/${month}`)
        .then(res => {
          if (!res.data.success) return;

          // 1) ปรับ header ของตาราง (จำนวนวัน)
          this.generateDayHeaders(res.data.year, res.data.month);

          // 2) เตรียม labels (1..N)
          const labels = Array.from(
            { length: res.data.days },
            (_, i) => (i + 1).toString()
          );

          // 3) สร้าง palette สีสำหรับแต่ละร้าน
          const palette = ['#86bc3a', '#2ab88b', '#3b82f6', '#f59e0b', '#ef4444'];

          // 4) เตรียม datasets
          const datasets = res.data.data.map((storeRow, idx) => ({
            label: storeRow.store_name,
            data: labels.map((_, j) => storeRow[`date_${j + 1}`] || 0),
            borderColor: palette[idx % palette.length],
            backgroundColor: palette[idx % palette.length],
            fill: false,
            tension: 0.1,
            borderWidth: 2
          }));

          // 5) สร้างหรืออัปเดตกราฟ
          if (this.myChart) this.myChart.destroy();
          const ctx = document.getElementById('myChart').getContext('2d');
          this.myChart = new Chart(ctx, {
            type: 'line',
            data: { labels, datasets },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: { stacked: true },
                y: {
                  stacked: true,
                  beginAtZero: true
                }
              },
              plugins: {
                legend: { position: 'top' },
                tooltip: { mode: 'index', intersect: false }
              }
            }
          });
        })
        .catch(console.error);
    },
    onSearchWholesaleChart() {
      // 1) เตรียมพาราม์
      const storeIds = this.storeDetail.id;
      const year = this.selected_year_wholesale;

      // 2) เรียก API
      HTTP.get(`/dashboards/wholesaleReport/${storeIds}/${year}`)
        .then(res => {
          if (!res.data.success) return;

          // 3) เก็บผลลัพธ์ลงตัวแปรกลาง
          const chartData = res.data.data.map(item => {
            const row = { store_name: item.store_name };
            for (let m = 1; m <= 12; m++) {
              row[`month_${m}`] = item[`month_${m}`] || 0;
            }
            return row;
          });

          // 4) แกน Y: ชื่อเดือน (labels)
          const labels = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
            'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
            'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
          ];

          // 5) พาเลตต์สี
          const palette = ['#86bc3a', '#2ab88b', '#3b82f6', '#f59e0b', '#ef4444'];

          // 6) เตรียม datasets (stacked, horizontal)
          const datasets = chartData.map((row, idx) => ({
            label: row.store_name,
            data: labels.map((_, i) => row[`month_${i + 1}`]),
            backgroundColor: palette[idx % palette.length],
            borderColor: palette[idx % palette.length],
            borderWidth: 1,
            stack: 'stack1'
          }));

          // 7) สร้าง data + config
          const data = { labels, datasets };
          const config = {
            type: 'bar',
            data,
            options: {
              indexAxis: 'y',       // horizontal bar  
              responsive: true,
              maintainAspectRatio: false,
              interaction: {
                mode: 'nearest',    // จับจุดใกล้เคียงที่สุด
                axis: 'xy',         // ใช้ทั้งแกน x+y
                intersect: true     // ต้องเล็งตรงบาร์ ถึงจะแสดง
              },
              plugins: {
                tooltip: {
                  mode: 'nearest',
                  axis: 'xy',
                  intersect: true
                },
                legend: { position: 'top' }
              },
              datasets: {
                bar: {
                  barPercentage: 0.6,
                  categoryPercentage: 0.8
                }
              },
              scales: {
                x: {
                  stacked: true,
                  beginAtZero: true,
                  title: { display: true, text: 'ยอดขายรวม' }
                },
                y: {
                  stacked: true,
                  ticks: { autoSkip: false, padding: 8 }
                }
              }
            }
          };



          // 8) วาดหรืออัปเดตกราฟ
          if (this.myChart_store_other) {
            this.myChart_store_other.destroy();
          }
          const ctx = document.getElementById('myChart_store_other').getContext('2d');
          this.myChart_store_other = new Chart(ctx, config);
        })
        .catch(console.error);
    },

    async chart_bar() {
      const storeId = this.storeDetail.id
      const year = this.selected_year_sale
      const month = this.selected_month_sale

      if (!storeId) return console.warn('ยังไม่มี storeId')
      try {
        const res = await HTTP.get(`/dashboards/saleReportByStore/${storeId}/${year}/${month}`)
        if (!res.data.success) return

        const labels = Array.from({ length: res.data.days }, (_, i) => (i + 1).toString())
        const row = res.data.data[0] || {}

        const datasets = [{
          label: row.store_name || 'ยอดขาย',
          data: labels.map((_, i) => row[`date_${i + 1}`] || 0),
          borderColor: 'rgb(140,198,62)',
          backgroundColor: 'rgb(140,198,62)',
          fill: false,
          tension: 0.1,
          borderWidth: 1
        }]

        if (this.myChart) this.myChart.destroy()
        const ctx = document.getElementById('myChart').getContext('2d')
        this.myChart = new Chart(ctx, {
          type: 'line', data: { labels, datasets }, options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: { x: { stacked: true }, y: { stacked: true } }
          }
        })
      } catch (e) {
        console.error('chart_bar error', e)
      }
    },


    async chart_line() {
      // 1) เตรียม storeIds และปี
      const storeIds = this.storeDetail.id;        // หรือถ้าเลือกหลายร้าน ก็ join(',') ได้
      const year = this.selected_year_wholesale;  // หรือ v-model ที่คุณใช้เก็บปี

      try {
        // 2) เรียก API wholesaleReport
        const res = await HTTP.get(`/dashboards/wholesaleReport/${storeIds}/${year}`);
        if (!res.data.success) return;

        // 3) เก็บผลลัพธ์เป็น array ของ object แบบ { store_name, month_1, ..., month_12 }
        this.wholesaleReportList = res.data.data.map(item => {
          const row = { store_name: item.store_name };
          for (let m = 1; m <= 12; m++) {
            row[`month_${m}`] = item[`month_${m}`] || 0;
          }
          return row;
        });

        // 4) เตรียม labels (ชื่อเดือน)
        const labels = [
          'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
          'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
          'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
        ];

        // 5) palette สี
        const palette = ['#86bc3a', '#2ab88b', '#3b82f6', '#f59e0b', '#ef4444'];

        // 6) สร้าง datasets จากแต่ละ store
        const datasets = this.wholesaleReportList.map((row, idx) => ({
          label: row.store_name,
          data: labels.map((_, i) => row[`month_${i + 1}`]),
          borderColor: palette[idx % palette.length],
          backgroundColor: palette[idx % palette.length],
          fill: false,
          tension: 0.1,
          borderWidth: 2,
        }));

        // 7) ถ้ามีกราฟเก่า ให้ destroy ก่อน
        if (this.myChart_store_other) this.myChart_store_other.destroy();

        // 8) สร้าง Bar Chart บน canvas#myChart_store_other
        const ctx = document.getElementById('myChart_store_other').getContext('2d');
        this.myChart_store_other = new Chart(ctx, {
          type: 'bar',
          data: { labels, datasets },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: { stacked: false },
              y: { beginAtZero: true }
            },
            plugins: {
              legend: { position: 'top' },
              tooltip: { mode: 'index', intersect: false }
            }
          }
        });

      } catch (err) {
        console.error('chart_line error', err);
      }
    },

    async get_data() {
      this.overlay = true
      await HTTP.post('/inventory/dashboards/amount')
        .then((res) => {
          if (res.data.success === true) {
            this.product_expireds = res.data.object.product_expireds
            this.low_stock = res.data.object.low_stock
            this.cn = res.data.object.cn
            this.promotion_expireds = res.data.object.promotion_expireds
            this.promotion_mains = res.data.object.promotion_mains
            if (res.data.object.promotion_sets) {
              this.promotion_sets = res.data.object.promotion_sets
            }
            this.mains = res.data.object.mains
            this.expireds = res.data.object.expireds
            this.damages = res.data.object.damages
            this.returns = res.data.object.returns
            this.reducts = res.data.object.reducts
            this.dumps = res.data.object.dumps
            this.product_set_price = res.data.object.product_set_price
            this.product_low_cost = res.data.object.product_low_cost
            this.product_high_cost = res.data.object.product_high_cost
            this.product_not_set_price = res.data.object.product_not_set_price
            this.product_close = res.data.object.product_close
          }
        })
    },
    async get_data_table() {
      await HTTP.post('/inventory/dashboards/productswarehouse', {
        limit: 0
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.data_list = res.data.object
        }
      })
    },

    continue_qty() {
      const id = 1
      this.$router.push('/warehousereport/warehousequantity/' + id)
    },
  },
  mounted() {
    const branchId = this.$route.params.customerCode;
    this.fetchStoreDetail(branchId)
      .then(() => {
        this.chart_bar();
        this.chart_line();
        this.loadBestSellingProducts();
        this.loadWorstSellingProducts();
      });

    this.loadProductTypes();
    this.year_function()
    this.get_data()
    this.get_data_table()

  }
}
</script>

<style scoped>
.grid_line_first {
  display: grid;
  grid-template-columns: 55% 45%;
  grid-gap: 15px 0;
}

.grid_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}

.grid_three_stock {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}

.grid_line_second {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}

.hover_text {
  cursor: pointer;
  color: black !important;
  transition: 0.1s;
}

.hover_text:hover {
  color: #8cc63e !important;
  transition: 0.1s;
}

.grid_count {
  display: grid;
  grid-template-columns: 25% 75%;
}

.grid_header {
  display: grid;
  grid-template-columns: 15% 85%;
}

.grid_header_product {
  display: grid;
  grid-template-columns: 20% 80%;
}

.grid_header_drop {
  display: grid;
  grid-template-columns: 10% 90%;
}

.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}

.grid_header_quantity {
  display: grid;
  grid-template-columns: 5% 95%;
}

.bill_payment_select {
  width: 80%;
  margin-left: auto;
}

.bill_payment_detail {
  display: grid;
  grid-template-columns: 25% 75%;
}

.grid_select_tax_report {
  display: grid;
  grid-template-columns: 35% 65%;
}

.grid_select_tax_report_excel {
  text-align: right;
}

@media only screen and (max-width: 1180px) {
  .grid_line_first {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_header_product {
    display: grid;
    grid-template-columns: 10% 90%;
  }

  .grid_header_drop {
    display: grid;
    grid-template-columns: 13% 87%;
  }

  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_header_quantity {
    display: grid;
    grid-template-columns: 10% 90%;
  }

  .bill_payment_select {
    width: 100%;
    margin-left: unset;
  }

  .bill_payment_list {
    display: grid;
    grid-template-columns: 50% 50%;
  }

  .grid_select_tax_report {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_select_tax_report_excel {
    text-align: unset;
    width: 100%;
  }

  .grid_select_tax_report_excel_button {
    width: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_header_product {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_select {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_header_drop {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_header_quantity {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_header {
    display: grid;
    grid-template-columns: 30% 70%;
  }

  .grid_three_stock {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }

  .bill_payment_detail {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
</style>
